<template>
  <v-select
      v-model="value"
      :items="items"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";

export default {
  name: "r-trigger-scope",
  props: {
    model: VueTypes.instanceOf(Object),
    items: VueTypes.array.def([]),
    label: VueTypes.string.def("Scope:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    }
  }
}

</script>